module.exports = __webpack_public_path__ + "img/Slice3-min.e21a8d85.png";